import React from 'react';
import Home from 'view/Layout/Project/Home';
import QueryOrder from 'view/Layout/Project/OrderQuery';
import RcvQuery from 'view/Layout/Project/RcvQuery';
import RtnQuery from 'view/Layout/Project/RtnQuery';
import { EnumLayoutRouter } from './enum';
import IrouterData from './type';

const LAYOUT_ROUTER: IrouterData[] = [
  { url: EnumLayoutRouter.首頁, component: <Home /> },
  { url: EnumLayoutRouter.訂單下載, component: <QueryOrder /> },
  { url: EnumLayoutRouter.驗收單下載, component: <RcvQuery /> },
  { url: EnumLayoutRouter.退貨單下載, component: <RtnQuery /> },
];

export default LAYOUT_ROUTER;
